export default {
  data() {
    return {
      isShowBatch: true, // 是否显示批量按钮
      multipleSelection: new Map(), // 选中对象 map 集合
      pageSelection: new Map(), // 当前分页存储的 map 集合
    };
  },
  mounted() {},
  methods: {
    // 批量设置
    handleConfig() {
      this.isShowBatch = false;
    },
    // 批量选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 全部选中
    handleAllchange(selection) {
      if (selection.length > 0) {
        this.pageSelection.set(this.currentPage, [...selection]);
        selection.forEach((item) => {
          if (!this.multipleSelection.has(item.id)) {
            this.multipleSelection.set(item.id, { ...item });
          }
        });
      } else if (this.pageSelection.length > 0) {
        const curSelection = this.pageSelection.get(this.currentPage);
        curSelection.forEach(({ id }) => {
          this.multipleSelection.delete(id);
        });
      }
    },
    // 单个手动勾选触发
    handleSingleChange(selection, row) {
      const { id } = row;
      // 存取 选中的数据
      if (this.multipleSelection.has(id)) {
        this.multipleSelection.delete(id);
      } else {
        this.multipleSelection.set(id, { ...row });
      }
    },
    // 指定选中
    toggleSelection(rows = []) {
      if (rows.length > 0) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 循环获取之前选中的数据
    findSelectionItem(tableList) {
      const tempList = [];
      tableList.forEach((item) => {
        if (this.multipleSelection.has(item.id)) {
          tempList.push(item);
        }
      });
      this.toggleSelection(tempList);
    },
    getDealArr() {
      const tempArr = [];
      [...this.multipleSelection.values()].forEach(({ id }) => {
        tempArr.push(id);
      });
      return tempArr.join(',');
    },
    // 清除 table 选择
    clearSelection() {
      this.multipleSelection.clear();
      this.pageSelection.clear();
      this.toggleSelection();
    },
  },
};
